import axios from 'axios';
import LangService from '../services/LangService';

export default {
    bearerToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpZCI6IjZlYjFmNTlkMWY3MWU5YjdmMzE3YWY0M2YzZGUzMTI2IiwiaXNzIjoiYXV0aCIsImp0aSI6IjZlYjFmNTlkMWY3MWU5YjdmMzE3YWY0M2YzZGUzMTI2IiwiYXVkIjoiMGUyNzg4ZjBiZjE2NzFiMSIsImV4cGlyZSI6NDEwMjM1ODQwMCwic2NvcGUiOiJwdWJsaWM6cmVhZCIsImRvbWFpbnMiOiJkZXZ3aWRnZXQubWVpbmUtbGFuZGF1c2ZsdWVnZS5kZSBib29raW5nLXdpZGdldC1hbm9zb3YyMjkwNzUuY29kZWFueWFwcC5jb20gc3RhdGljLm1laW5lLWxhbmRhdXNmbHVlZ2UuZGUgd2lkZ2V0Lm1laW5lLWxhbmRhdXNmbHVlZ2UuZGUgYm9va2luZy13aWRnZXQubG9jIHdpZGdldC5ib29raW5nLmxvYyB3aWRnZXQuaXRpbmVyYXJ5LmxvYyB3aWRnZXQuaXRpbmVyYXJ5LmxvYyBkZXZ3aWRnZXQubXktY3J1aXNlLWV4Y3Vyc2lvbi5jby51ayB0cmlwdXAubXVsdGkgdHJpcHVwY2gubXVsdGkgZXhjdXJzaW9uLm11bHRpIn0.NU0U-RvbGQC0Mk_uAZT1cVvcM3QwZunTErfFU5GAVV9j7Wl9pUHZvHEBggx9avUGYEOt2nYDMBZd0hoYNPoAGQykQJIQoqf9hCjLxX304ZPCnG3Q2BVKExaSohsD2LD10RIms_exTGEIci6bjdBzvAYDHUDbH0H_JL6wMqHW7WI',
    domain: "http://devapi.meine-landausfluege.de",

    HTTP: function () {
        return axios.create({
            baseURL: LangService.getUrlApi() + '/cruise/v1/',
            headers: {
                Authorization: 'Bearer ' + this.bearerToken
            }
        });
    },

    getPorts: function (type='sea') {
        return this.HTTP().get(`ports?type=${type}`)
            .then(function (response) {
                return response.data
            })
            .catch(err => {
                throw new window.ApiError(err);
            })
    },

    getCompanies: function (type="sea") {
        return this.HTTP().get(`companies?type=${type}`)
            .then(function (response) {
                return response.data
            })
            .catch(err => {
                throw new window.ApiError(err);
            })
    },

    getShip: function (cruiseCompanyId) {
        return this.HTTP().get('companies/' + cruiseCompanyId + '/ships')
            .then(function (response) {
                return response.data
            })
            .catch(err => {
                throw new window.ApiError(err);
            })
    },

    getCruise: function (cruiseShipId) {
        return this.HTTP().get('cruises/find-by-shipid?id=' + cruiseShipId)
            .then(function (response) {
                return response.data
            })
            .catch(err => {
                throw new window.ApiError(err);
            })
    },

    getDestinations: function () {
        return this.HTTP().get('destinations')
          .then(function (response) {
              return response.data
          })
          .catch(err => {
              throw new window.ApiError(err);
          })
    }
}
